// menu.js
const hamburger = document.getElementById('hamburger');
const hamburgerIcon = hamburger.querySelector('.menu-open');
const closeIcon = hamburger.querySelector('.menu-close');

const nav = document.getElementById('nav');

// open menu with hamburger
hamburger.addEventListener('click', () => {

  // show nav 
  nav.classList.toggle('open');

  // toggle the hidden class
  hamburgerIcon.classList.toggle('hidden');
  closeIcon.classList.toggle('hidden');

  // toggle class on html
  document.documentElement.classList.toggle('no-scroll');

});